import { render } from "./xtx-more.vue?vue&type=template&id=3ac11456&scoped=true"
import script from "./xtx-more.vue?vue&type=script&lang=js"
export * from "./xtx-more.vue?vue&type=script&lang=js"

import "./xtx-more.vue?vue&type=style&index=0&id=3ac11456&scoped=true&lang=less"

import exportComponent from "D:\\hbuilderxpro\\jxshop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac11456"]])

export default __exports__